var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resourceStatus)?_c('StatusBadge',{class:_vm.$style.statusBadge,attrs:{"status":_vm.resourceStatus.indicator,"text":_vm.resourceStatus.label}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }